'use client';

import { ReactNode, useEffect, useState } from 'react';
import { Button } from 'react-aria-components';

import { styles } from './UiKitTagBase.styles';

export interface TagRenderState {
  selected: boolean;
  disabled: boolean;
}

export interface UiKitTagBaseProps {
  onSelectionChange?: (key: string, selected: boolean) => void;
  children: ReactNode | ((state: TagRenderState) => ReactNode);
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  onChange?: (selected: boolean) => void;
  value?: string;
}

export function UiKitTagBase({
  children,
  className,
  selected: controlledSelected = false,
  disabled = false,
  onChange,
  onSelectionChange,
  value
}: UiKitTagBaseProps) {
  const [selected, setSelected] = useState(controlledSelected);

  const slots = styles({ selected, disabled });

  useEffect(() => {
    setSelected(controlledSelected);
  }, [controlledSelected]);

  const handleClick = () => {
    if (disabled) return;

    const newState = !selected;
    setSelected(newState);
    onChange?.(newState);

    if (value) {
      onSelectionChange?.(value, newState);
    }
  };

  const renderState: TagRenderState = {
    selected,
    disabled
  };

  const content =
    typeof children === 'function' ? children(renderState) : children;

  return (
    <Button
      className={slots.base({ className })}
      onPress={handleClick}
      isDisabled={disabled}
    >
      {content}
    </Button>
  );
}
